import React from 'react';
import {
    Tooltip,
    IconButton,
    Checkbox,
    Box,
    Typography,
    Link,
    Chip,
    Button,
    CircularProgress
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import { createTheme } from '@mui/material/styles';
import CircleIcon from '@mui/icons-material/Circle';
import airSvg from '../../assets/images/airSvg.svg';
import groundSvg from '../../assets/images/sedan_black_small.svg';
import Switch from '@mui/material/Switch';
import Popover from '@mui/material/Popover';
import completedSvg from '../../assets/images/completedSvg.svg';
import notCompletedSvg from '../../assets/images/notCompletedSvg.svg';
import rejectSvg from '../../assets/images/rejectSvg.svg';
import notRejectSvg from '../../assets/images/notRejectSvg.svg';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import ProfileInitial from '../profile/profileInitial';
import Badge from '@mui/material/Badge';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import EmailIcon from '@mui/icons-material/EmailOutlined';
import Stack from '@mui/material/Stack';
import AttachmentOutlinedIcon from '@mui/icons-material/AttachmentOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { FULL_PERMISSION } from '../../constants/Constant';
import Divider from '@mui/material/Divider';
import { lightGreen, red } from '@mui/material/colors';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    columnContent: {
        display: 'flex',
        flexDirection: 'row',
        //height: 'auto',
        flexWrap: 'wrap',
        //justifyContent: 'center',
        alignItems: 'center',
        // this logic needs to be handle for mobile view
        // [theme.breakpoints.only('xs')]: {
        //     flexBasis: '19%',
        // },
    },
    wrapTextStyle: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '40ch',
    },
    wrapTextSmallSize: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '30ch',
        fontSize: 12,
    },
    wrapAll: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '20ch',
    },
    transportLogo: {
        height: 15,
        width: 20,
    },
    mailLogo: {
        height: 15,
        width: 20,
        marginRight: 5,
    },

    actionIcon: {
        width: 20,
    },
    setScale: {
        transform: 'scale(1)',
        fontSize: '01rem',
        stroke: '#fff',
        strokeWidth: 1,
        marginTop: '-1px',
        marginLeft: 0,
        color: 'primary',
    },
    checkbox_style: {
        marginLeft: '-10px',
    },
}));

const DataListRowItem = (props) => {
    const classes = useStyles();
    const { row, item, index } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const onPopover = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closePopover = () => {
        setAnchorEl(null);
    };
    let ticketJsonData = [];
    if (
        row.label === 'Comp' ||
        row.label === 'Purchase' ||
        row.label === 'Add Purchase'
    ) {
        if (item.actualData?.ticketAllStarSetting.setting?.length > 0) {
            const jsonP = JSON.parse(
                item.actualData.ticketAllStarSetting.setting
            );
            if (jsonP.length > 0) {
                ticketJsonData.push(JSON.parse(jsonP[0].TicketSetting));
            }
        }
    }

    return (
        <Box
            className={classes.columnContent}
            sx={
                row.label === 'Action'
                    ? {
                        flex: `${row.width}`,
                        justifyContent: {
                            xs: 'flex-start',
                            md: 'flex-end',
                            lg: 'flex-end',
                        }
                    }
                    : !row.type && row.alignCenter != undefined
                        ? {
                            flex: `${row.width}`,
                            justifyContent: {
                                xs: 'flex-start',
                                md: 'flex-end',
                                lg: 'flex-end',
                            },
                        }
                        : row.alignLeft != undefined
                            ? {
                                flex: `${row.width}`,
                                justifyContent: 'left',
                            }
                            : {
                                flex: `${row.width}`,
                                justifyContent: 'left',
                            }
            }>
            {row.label === 'checkbox' ? (
                <Checkbox
                    inputProps={{
                        'aria-label': 'Participant',
                    }}
                    checked={item.selected ? item.selected : false}
                    onChange={(event) => props.onCheckSelect(event, index)}
                    // color="secondary"
                    value={row[row.key]}
                    disabled={
                        item.disableRow != undefined ? item.disableRow : false
                    }
                    className={classes.checkbox_style}
                />
            ) : row.label === 'Send' ? (
                <Button
                    variant="contained"
                    style={{ fontSize: 13 }}
                    onClick={() => props.handleClick()}>
                    Send{' '}
                </Button>
            ) : row.label === 'Action' ? (
                row.key == 'editnote' ? (
                    <>
                        {row[row.key] && row[row.key].trim().length > 0 ? (
                            <>
                                <Tooltip title="Note" aria-label="Note">
                                    <IconButton
                                        color="primary"
                                        onClick={(event) => {
                                            onPopover(event);
                                        }}>
                                        <TextSnippetOutlinedIcon color="primary" />
                                    </IconButton>
                                </Tooltip>
                                <Popover
                                    id={'simple-popover'}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={closePopover}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}>
                                    <Typography sx={{ p: 2 }}>
                                        {row[row.key]}
                                    </Typography>
                                </Popover>
                            </>
                        ) : null}
                        {props.modPermission &&
                            props.modPermission == FULL_PERMISSION ? (
                            <Tooltip title="Edit" aria-label="edit">
                                <IconButton
                                    color="primary"
                                    onClick={() => props.editRow(item)}
                                    disabled={
                                        item.disableRow != undefined
                                            ? item.disableRow
                                            : false ||
                                                props.readOnlyOrHide === 1
                                                ? true
                                                : false
                                    }>
                                    <EditOutlinedIcon
                                        fontSize="small"
                                        color={
                                            item.disableRow != undefined ||
                                                props.readOnlyOrHide === 1
                                                ? 'default'
                                                : 'primary'
                                        }
                                    />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </>
                ) : row[row.key] == 'Edit' ? (
                    props.modPermission &&
                        props.modPermission == FULL_PERMISSION ? (
                        <Tooltip title="Edit" aria-label="edit">
                            <IconButton
                                color="primary"
                                onClick={() => props.editRow(item)}
                                disabled={
                                    item.disableRow != undefined
                                        ? item.disableRow
                                        : false
                                }>
                                <EditOutlinedIcon
                                    fontSize="small"
                                    color={
                                        item.disableRow != undefined
                                            ? 'default'
                                            : 'primary'
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                    ) : null
                ) : props.modPermission &&
                    props.modPermission == FULL_PERMISSION ? (
                    <>
                        {/* {props.hideReject && (
                            <Tooltip title="Approve" aria-label="Approve">
                                <IconButton
                                    color="primary"
                                    onClick={() => {
                                        item.actualData.requestStatus ==
                                            'Pending' ||
                                        item.actualData.requestStatus ==
                                            'Rejected'
                                            ? props.onActionClick(
                                                  item,index,
                                                  'Approve'
                                              )
                                            : props.onPendingAction(item,index);
                                    }}
                                    sx={
                                        item.actualData.requestStatus ==
                                        'Pending'
                                            ? { cursor: 'pointer' }
                                            : item.actualData.requestStatus ==
                                              'Approved'
                                            ? { cursor: 'default' }
                                            : { cursor: 'pointer' }
                                    }>
                                    <Box
                                        component="img"
                                        className={classes.actionIcon}
                                        alt="logo."
                                        src={
                                            item.actualData.requestStatus ==
                                            'Pending'
                                                ? notCompletedSvg
                                                : item.actualData
                                                      .requestStatus ==
                                                  'Approved'
                                                ? completedSvg
                                                : notCompletedSvg
                                        }
                                    />
                                </IconButton>
                            </Tooltip>
                        )} */}
                        {props.hideReject && (
                            <Tooltip title="Approve" aria-label="Approve">
                                {props.approveloading.loading &&
                                    props.approveloading.index === index ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <IconButton
                                        color="primary"
                                        onClick={() => {
                                            if (
                                                item.actualData
                                                    .requestStatus ===
                                                'Pending' ||
                                                item.actualData
                                                    .requestStatus ===
                                                'Rejected'
                                            ) {
                                                props.onActionClick(
                                                    item,
                                                    index,
                                                    'Approve'
                                                );
                                            } else {
                                                props.onPendingAction(
                                                    item,
                                                    index
                                                );
                                            }
                                        }}
                                        sx={
                                            item.actualData.requestStatus ===
                                                'Pending'
                                                ? { cursor: 'pointer' }
                                                : item.actualData
                                                    .requestStatus ===
                                                    'Approved'
                                                    ? { cursor: 'default' }
                                                    : { cursor: 'pointer' }
                                        }>
                                        <Box
                                            component="img"
                                            className={classes.actionIcon}
                                            alt="logo."
                                            src={
                                                item.actualData
                                                    .requestStatus === 'Pending'
                                                    ? notCompletedSvg
                                                    : item.actualData
                                                        .requestStatus ===
                                                        'Approved'
                                                        ? completedSvg
                                                        : notCompletedSvg
                                            }
                                        />
                                    </IconButton>
                                )}
                            </Tooltip>
                        )}
                        {props.hideApprove && (
                            <Tooltip title="Reject" aria-label="Reject">
                                {props.rejectloading.loading &&
                                    props.rejectloading.index === index ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <IconButton
                                        color="primary"
                                        onClick={() => {
                                            if (
                                                item.actualData
                                                    .requestStatus ===
                                                'Pending' ||
                                                item.actualData
                                                    .requestStatus ===
                                                'Approved'
                                            ) {
                                                props.onActionClick(
                                                    item,
                                                    index,
                                                    'Reject'
                                                );
                                            } else {
                                                props.onPendingAction(
                                                    item,
                                                    index
                                                );
                                            }
                                        }}
                                        sx={
                                            item.actualData.requestStatus ===
                                                'Pending'
                                                ? { cursor: 'pointer' }
                                                : item.actualData
                                                    .requestStatus ===
                                                    'Rejected'
                                                    ? { cursor: 'default' }
                                                    : { cursor: 'pointer' }
                                        }>
                                        <Box
                                            component="img"
                                            className={classes.actionIcon}
                                            alt="logo."
                                            src={
                                                item.actualData
                                                    .requestStatus === 'Pending'
                                                    ? notRejectSvg
                                                    : item.actualData
                                                        .requestStatus ===
                                                        'Approved'
                                                        ? notRejectSvg
                                                        : rejectSvg
                                            }
                                        />
                                    </IconButton>
                                )}
                            </Tooltip>
                        )}

                        {/* {props.hideApprove && (
                            <Tooltip title="Reject" aria-label="Reject">
                                <IconButton
                                    color="primary"
                                    onClick={() => {
                                        item.actualData.requestStatus ==
                                            'Pending' ||
                                        item.actualData.requestStatus ==
                                            'Approved'
                                            ? props.onActionClick(
                                                  item,
                                                  index,
                                                  'Reject'
                                              )
                                            : props.onPendingAction(
                                                  item,
                                                  index
                                              );
                                    }}
                                    sx={
                                        item.actualData.requestStatus ==
                                        'Pending'
                                            ? { cursor: 'pointer' }
                                            : item.actualData.requestStatus ==
                                              'Rejected'
                                            ? { cursor: 'default' }
                                            : { cursor: 'pointer' }
                                    }>
                                    <Box
                                        component="img"
                                        className={classes.actionIcon}
                                        alt="logo."
                                        src={
                                            item.actualData.requestStatus ==
                                            'Pending'
                                                ? notRejectSvg
                                                : item.actualData
                                                      .requestStatus ==
                                                  'Approved'
                                                ? notRejectSvg
                                                : rejectSvg
                                        }
                                    />
                                </IconButton>
                            </Tooltip>
                        )} */}

                        <Tooltip title="Edit" aria-label="edit">
                            <IconButton
                                color="primary"
                                onClick={() => props.editRow(item)}
                                disabled={
                                    item.disableRow != undefined
                                        ? item.disableRow
                                        : false
                                }>
                                <EditOutlinedIcon
                                    fontSize="small"
                                    color={
                                        item.disableRow != undefined
                                            ? 'default'
                                            : 'primary'
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                    </>
                ) : null
            ) : row.label === 'Template' ? (
                <Tooltip title="Edit" aria-label="edit">
                    <IconButton
                        color="primary"
                        onClick={() => props.editTemplate(item)}
                        disabled={
                            item.disableRow != undefined
                                ? item.disableRow
                                : false
                        }>
                        <TextSnippetOutlinedIcon
                            fontSize="small"
                            color={
                                item.disableRow != undefined
                                    ? 'default'
                                    : 'primary'
                            }
                        />
                    </IconButton>
                </Tooltip>
            ) : row.label === 'Comp' ? (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={12}
                        fontWeight={500}
                        textAlign={'center'}
                        color="primary">
                        {row.label}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                Fri
                            </Typography>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {ticketJsonData && ticketJsonData.length > 0 && ticketJsonData[0]?.ticketFriCompCount ?
                                    ticketJsonData[0].ticketFriCompCount : 0}
                                /{ticketJsonData[0].ticketFriCompCount}
                            </Typography>
                        </Box>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                Sat
                            </Typography>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {ticketJsonData && ticketJsonData.length > 0 && ticketJsonData[0]?.ticketSatCompCount ? ticketJsonData[0].ticketSatCompCount : 0}
                                /{ticketJsonData[0].ticketSatCompCount}
                            </Typography>
                        </Box>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                Sun
                            </Typography>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {ticketJsonData && ticketJsonData.length > 0 && ticketJsonData[0]?.ticketSunCompCount ? ticketJsonData[0].ticketSunCompCount : 0}
                                /{ticketJsonData[0].ticketSunCompCount}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            ) : row.label === 'Purchase' ? (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={12}
                        fontWeight={500}
                        textAlign={'center'}
                        color="primary">
                        {row.label}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                Fri
                            </Typography>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {row.friUsedCount ? row.friUsedCount : 0}
                                /{ticketJsonData[0].ticketFriPurCount}
                            </Typography>
                        </Box>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                Sat
                            </Typography>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {row.satUsedCount ?
                                    row.satUsedCount : 0}
                                /{ticketJsonData[0].ticketSatPurCount}
                            </Typography>
                        </Box>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                Sun
                            </Typography>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {row.sunUsedCount ? row.sunUsedCount : 0}
                                /{ticketJsonData[0].ticketSunPurCount}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            ) : row.label === 'Add Purchase' ? (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={12}
                        fontWeight={500}
                        textAlign={'center'}
                        color="primary">
                        {row.label}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                Fri
                            </Typography>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {row.friAddUsedCount ? row.friAddUsedCount : 0}
                                /{ticketJsonData[0].ticketFriAddPurCount}
                            </Typography>
                        </Box>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                Sat
                            </Typography>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {row.satAddUsedCount ? row.satAddUsedCount : 0}
                                /{ticketJsonData[0].ticketSatAddPurCount}
                            </Typography>
                        </Box>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={12}
                                fontWeight={500}
                                color="primary">
                                Sun
                            </Typography>
                            <Typography
                                variant="h4"
                                flexGrow={1}
                                fontSize={14}
                                fontWeight={400}>
                                {row.sunAddUsedCount ? row.sunAddUsedCount : 0}
                                /{ticketJsonData[0].ticketSunAddPurCount}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            ) : row.label === 'Allotment' ? (
                <>
                    <Box sx={{ display: 'flex', flexDirection: 'column', marginRight: 2 }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            textAlign={'center'}
                            fontWeight={500}
                            color="primary">
                            {row.label}
                        </Typography>
                        {/* <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            fontWeight={500}
                            textAlign={'center'}
                            color="primary">
                            Comp/Pay
                        </Typography>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={14}
                            textAlign={'center'}
                            fontWeight={400}>
                                {row.hotelSettingData[0].comp}
                            {/* {(item.actualData?.allotments?.length > 0 && item.actualData?.allotments !== undefined) ? item.actualData.allotments[0].hotelSetting !== null ? JSON.parse(item.actualData.allotments[0].hotelSetting).comp !== "" ? JSON.parse(item.actualData.allotments[0].hotelSetting).comp + '/' + JSON.parse(item.actualData.allotments[0].hotelSetting).pay : 0 : 0 : 0} */}
                        {/* </Typography> */}
                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    textAlign={'center'}
                                    fontWeight={500}
                                    color="primary">
                                    Comp
                                </Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            fontSize={12}
                                            textAlign={'center'}
                                            fontWeight={500}
                                            color="primary">
                                            Used
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            textAlign={'center'}
                                            fontSize={14}
                                            fontWeight={400}>
                                            {row.hotelSettingData && row.hotelSettingData.length > 0
                                                ? ((row.hotelSettingRemainingcount !==
                                                    undefined && row.hotelSettingRemainingcount != 0)
                                                    ? row
                                                        .hotelSettingRemainingcount[0]
                                                        .comp
                                                    : 0)
                                                : 0}
                                        </Typography>
                                    </Box>
                                    <Divider
                                        orientation="vertical"
                                        flexItem
                                        sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                                    />
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            fontSize={12}
                                            textAlign={'center'}
                                            fontWeight={500}
                                            color="primary">
                                            Alloted
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            textAlign={'center'}
                                            fontSize={14}
                                            fontWeight={400}>
                                            {row.hotelSettingData.length > 0
                                                ?
                                                row.hotelSettingData[0].comp
                                                : 0}
                                        </Typography>
                                    </Box>

                                </Box>
                            </Box>
                            <Divider
                                orientation="vertical"
                                flexItem
                                sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                            />
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    textAlign={'center'}
                                    fontWeight={500}
                                    color="primary">
                                    Pay
                                </Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            fontSize={12}
                                            textAlign={'center'}
                                            fontWeight={500}
                                            color="primary">
                                            Used
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            textAlign={'center'}
                                            fontSize={14}
                                            fontWeight={400}>
                                            {row.hotelSettingData.length > 0
                                                ? ((row.hotelSettingRemainingcount !==
                                                    undefined && row.hotelSettingRemainingcount !=
                                                    0)
                                                    ? row
                                                        .hotelSettingRemainingcount[0]
                                                        .pay
                                                    : 0)
                                                : 0}
                                        </Typography>
                                    </Box>
                                    <Divider
                                        orientation="vertical"
                                        flexItem
                                        sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                                    />
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            fontSize={12}
                                            textAlign={'center'}
                                            fontWeight={500}
                                            color="primary">
                                            Alloted
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            textAlign={'center'}
                                            fontSize={14}
                                            fontWeight={400}>
                                            {row.hotelSettingData.length > 0
                                                ?
                                                row.hotelSettingData[0].pay
                                                : 0}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </>
            ) : row.label === 'CredAllotment' ? (
                <>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography
                            variant="h4"
                            flexGrow={1}
                            fontSize={12}
                            textAlign={'center'}
                            fontWeight={500}
                            color="primary">
                            Allotment
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}>

                                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            fontSize={12}
                                            textAlign={'center'}
                                            fontWeight={500}
                                            color="primary">
                                            Used
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            textAlign={'center'}
                                            fontSize={14}
                                            fontWeight={400}>
                                            {row.hotelSettingRemainingcount && row.hotelSettingRemainingcount.length > 0
                                                ? (row.hotelSettingRemainingcount
                                                    ? row.hotelSettingRemainingcount[0].used
                                                    : 0)
                                                : 0}
                                        </Typography>
                                    </Box>
                                    <Divider
                                        orientation="vertical"
                                        flexItem
                                        sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                                    />
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            fontSize={12}
                                            textAlign={'center'}
                                            fontWeight={500}
                                            color="primary">
                                            Alloted
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            flexGrow={1}
                                            textAlign={'center'}
                                            fontSize={14}
                                            fontWeight={400}>
                                            {row.hotelSettingData && row.hotelSettingData.length > 0
                                                ?
                                                row.hotelSettingData[0] && row.hotelSettingData[0] !== null ? row.hotelSettingData[0].credential : 0
                                                : 0}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </>
            ) : row.label === 'History' ? (
                <Tooltip title="Change Log" aria-label="changelog">
                    <IconButton
                        color="primary"
                        onClick={() => props.showHistory(item)}
                        disabled={
                            item.disableRow != undefined
                                ? item.disableRow
                                : false
                        }>
                        <VisibilityOutlinedIcon
                            fontSize="small"
                            color={
                                item.disableRow != undefined
                                    ? 'default'
                                    : 'primary'
                            }
                        />
                    </IconButton>
                </Tooltip>
            ) : row.label === 'Attachment' ? (
                row.showAttachmentIcon ? (
                    <Tooltip title="Attachment" aria-label="attachments">
                        <IconButton color="primary">
                            <AttachmentOutlinedIcon
                                fontSize="small"
                                color={
                                    item.disableRow != undefined
                                        ? 'default'
                                        : 'primary'
                                }
                            />
                        </IconButton>
                    </Tooltip>
                ) : null
            ) : row.label === 'SenMail' ? (
                <Tooltip title="Send" aria-label="send">
                    <IconButton
                        color="primary"
                        onClick={() => props.editSendEmail(item)}
                        disabled={
                            item.disableRow != undefined
                                ? item.disableRow
                                : false
                        }>
                        <EmailIcon
                            fontSize="small"
                            color={
                                item.disableRow != undefined
                                    ? 'default'
                                    : 'primary'
                            }
                        />
                    </IconButton>
                </Tooltip>
            ) : row.label === 'ClipBoard' ? (
                <Tooltip title="Copy To Clipboard" aria-label="copyToClipboard">
                    <IconButton
                        color="primary"
                        onClick={() => props.copyToClipboard(item)}
                    // disabled={!row.showClipBoardIcon}
                    >
                        <ContentCopyOutlinedIcon
                            fontSize="small"
                            color={
                                item.disableRow != undefined
                                    ? 'default'
                                    : 'primary'
                            }
                        />
                    </IconButton>
                </Tooltip>
            ) : row.label === 'SenUserMail' ? (
                // row.showEmailIcon ?
                <Tooltip title="Send" aria-label="send">
                    <IconButton
                        color="primary"
                        onClick={() => props.editSendEmail(item)}
                        disabled={
                            !row.showEmailIcon || item.actualData.active == 0
                        }>
                        <EmailIcon
                            fontSize="small"
                            color={
                                row.showEmailIcon && item.actualData.active == 1
                                    ? 'primary'
                                    : 'default'
                            }
                        />
                    </IconButton>
                </Tooltip>
            ) : // : null
                // <Tooltip title="Template name" aria-label="Template Name">
                //     <IconButton
                //         color="primary"
                //         onClick={() => props.editTemplate(item)}

                //     >
                //         <TextSnippetOutlinedIcon color="primary" />
                //     </IconButton>
                // </Tooltip>
                row.label === 'Shared' ||
                    (row[row.key] && row[row.key].length >= 0) ? (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection:
                                row.inColumn != undefined ? 'column' : 'row',
                            justifyContent:
                                row.alignCenter != undefined
                                    ? row.type
                                        ? 'left'
                                        : 'center'
                                    : 'left',
                            alignItems:
                                row.alignCenter != undefined ? 'center' : 'start',
                            flexWrap:
                                row.wrapUp != undefined && row.wrapUp
                                    ? 'wrap'
                                    : 'nowrap',
                        }}>
                        {/* {row.showTemplateIcon ?
                            <Box
                                component="img"
                                className={
                                    classes.mailLogo
                                }
                                alt="air"
                                src={
                                    mailPng
                                }
                            />
                            : null} */}
                        {row.showLabel == undefined ? (
                            <Box>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    {row.label}
                                </Typography>
                            </Box>
                        ) : null}
                        {row.type ? (
                            <IconButton>
                                {row.type == 'ground' ? (
                                    <Box
                                        component="img"
                                        className={classes.transportLogo}
                                        alt="ground"
                                        src={groundSvg}
                                    />
                                ) : (
                                    <Box
                                        component="img"
                                        className={classes.transportLogo}
                                        alt="air"
                                        src={airSvg}
                                    />
                                )}
                            </IconButton>
                        ) : null}
                        {row.showChips != undefined ? (
                            row[row.key] ? (
                                row[row.key].split(', ').map((chipItem) => {
                                    return (
                                        <Chip
                                            key={chipItem}
                                            label={chipItem}
                                            sx={{ mr: '4px', mb: '2px' }}
                                        />
                                    );
                                })
                            ) : null
                        ) : row.showStatusIcon != undefined ? (
                            <Tooltip title={row[row.key] == 'Rejected' ? 'Not Approved' : row[row.key]  } aria-label={row[row.key]}>
                                <CircleIcon
                                    fontSize="small"
                                    style={{
                                        color:
                                            row[row.key] == 'Pending'
                                                ? '#F9B811'
                                                : row[row.key] == 'Approved'
                                                    ? '#169D3C'
                                                    : '#C81020',
                                    }}
                                />
                            </Tooltip>
                        ) : row.showSwitch != undefined ? (
                            <Switch
                                disabled={
                                    props.modPermission &&
                                        props.modPermission == FULL_PERMISSION
                                        ? false
                                        : true
                                }
                                checked={
                                    row[row.key] != undefined ? row[row.key] : false
                                }
                                onChange={(e) =>
                                    props.onSwitchToggle(e, index, item)
                                }
                                inputProps={{ 'aria-label': 'controlled' }}
                                color={'success'}
                            />
                        ) : // <IOSSwitch
                            //     sx={{
                            //         m: 1,
                            //     }}
                            //     checked={
                            //         row[row.key]
                            //     }
                            //     onChange={(
                            //         e
                            //     ) =>
                            //         props.onSwitchToggle(
                            //             e,
                            //             index,
                            //             item
                            //         )
                            //     }
                            // />
                            row.asList !== undefined ? (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                    }}>
                                    <Stack
                                        direction="row"
                                        spacing={-1.8}
                                        flexWrap="wrap">
                                        {!props.endUser &&
                                            row[row.key].map((rowItem, rowIndex) => {
                                                return (
                                                    <IconButton
                                                        key={`profile_${rowIndex}`}
                                                        size="small"
                                                        aria-label="account of current user"
                                                        aria-controls="primary-search-account-menu"
                                                        aria-haspopup="true"
                                                        color="inherit"
                                                        onClick={() =>
                                                            props.deleteConnection(
                                                                rowItem
                                                            )
                                                        }>
                                                        <Badge
                                                            overlap="circular"
                                                            anchorOrigin={{
                                                                vertical: 'bottom',
                                                                horizontal: 'left',
                                                            }}
                                                            badgeContent={
                                                                <RemoveCircleIcon
                                                                    fontSize="small"
                                                                    sx={{
                                                                        color: 'red',
                                                                    }}
                                                                    className={
                                                                        classes.setScale
                                                                    }></RemoveCircleIcon>
                                                            }>
                                                            <ProfileInitial
                                                                data={rowItem}
                                                                showOnlyInitial={true}
                                                                navigationScreen={
                                                                    'changeUser'
                                                                }
                                                            />
                                                            {/* <GroupAvatar
                                                        data={rowItem}
                                                    /> */}
                                                        </Badge>
                                                    </IconButton>
                                                );
                                            })}
                                    </Stack>

                                    {row.showAdd != undefined && (
                                        <IconButton
                                            color="primary"
                                            onClick={() => props.addConnection(item)}
                                            disabled={
                                                item.disableRow != undefined
                                                    ? item.disableRow
                                                    : false
                                            }>
                                            <AddCircleRoundedIcon
                                                fontSize="small"
                                                color={
                                                    item.disableRow != undefined
                                                        ? 'default'
                                                        : 'primary'
                                                }
                                            />
                                        </IconButton>
                                    )}
                                    {row.showAddLinkedWith != undefined && (
                                        <IconButton
                                            color="primary"
                                            onClick={() =>
                                                props.addConnectionLinkedWith(item)
                                            }
                                            disabled={
                                                item.disableRow != undefined
                                                    ? item.disableRow
                                                    : false
                                            }>
                                            <AddCircleRoundedIcon
                                                fontSize="small"
                                                color={
                                                    item.disableRow != undefined
                                                        ? 'default'
                                                        : 'primary'
                                                }
                                            />
                                        </IconButton>
                                    )}
                                </Box>
                            ) : (
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}>
                                    {row[row.key] ? (
                                        row.addLink ? (
                                            <Link
                                                component="button"
                                                variant="body2"
                                                onClick={() => props.viewPage(item)}
                                                className={classes.wrapTextStyle}>
                                                {row[row.key]}
                                            </Link>
                                        ) : row.showTooltip != undefined ? (
                                            <Tooltip title={row[row.key]}>
                                                <span
                                                    className={
                                                        row.wrapAll
                                                            ? classes.wrapAll
                                                            : classes.wrapTextStyle
                                                    }>
                                                    {row[row.key]}
                                                </span>
                                            </Tooltip>
                                        ) : (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}>
                                                <Tooltip title={row[row.key]}>
                                                    {row.key === 'participant' ? (
                                                        <Box>
                                                            <Box>
                                                                <span
                                                                    className={
                                                                        row.isSent
                                                                            ? classes.wrapTextSmallSize
                                                                            : classes.wrapTextStyle
                                                                    }>
                                                                    {row[
                                                                        row.key
                                                                    ].search(
                                                                        'DELETED'
                                                                    ) !== -1 && (
                                                                            <span
                                                                                style={{
                                                                                    color: 'red',
                                                                                }}>{`DELETED`}</span>
                                                                        )}
                                                                    {row[
                                                                        row.key
                                                                    ].replace(
                                                                        'DELETED',
                                                                        ''
                                                                    )}

                                                                    {row.showEmail &&
                                                                        row.toEmail ? (
                                                                        <Typography
                                                                            fontSize={
                                                                                11
                                                                            }
                                                                            sx={{
                                                                                display:
                                                                                    '-webkit-box',
                                                                                boxOrient:
                                                                                    'vertical',
                                                                                lineClamp: 2,
                                                                                wordBreak:
                                                                                    'break-word',
                                                                                overflow:
                                                                                    'hidden',
                                                                                pr: 1,
                                                                                whiteSpace: 'normal'
                                                                            }}>
                                                                            <a
                                                                                href={`mailto:${row.toEmail}`}>
                                                                                {' '}
                                                                                {
                                                                                    row.toEmail
                                                                                }{' '}
                                                                            </a>
                                                                        </Typography>
                                                                    ) : null}
                                                                </span>
                                                                {row.showEventType &&
                                                                    row.showEventType !== '' ? (
                                                                    <Typography fontSize={11}>
                                                                        {row.eventType}{' '}
                                                                    </Typography>
                                                                ) : null}
                                                            </Box>
                                                        </Box>
                                                    ) : (
                                                        <span
                                                            style={{
                                                                marginRight: 10,
                                                                color: row[row.key] === 'Waitlist Request' ? 'red' : (row[row.key] === 'Complimentary' ? 'green' : (row[row.key] === 'For Purchase' ? 'orange' : 'black'))
                                                            }}
                                                            className={row.isSent ? classes.wrapTextSmallSize : classes.wrapTextStyle}>
                                                            {row[row.key]}
                                                        </span>
                                                    )}
                                                </Tooltip>
                                            </Box>
                                        )
                                    ) : (
                                        ''
                                    )}
                                </Typography>
                            )}
                    </Box>
                ) : null}
        </Box>
    );
};
export default DataListRowItem;
